module.exports = __webpack_public_path__ + "public/Icons/lightModeOn.svg?a25cda4b";